import React from "react";
import ColorWheel from "../components/ColorWheel";
import AppContext from "../context/AppProvider";
import { useContext } from "react";
import { AiFillHome } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

const SettingsPage = () => {
  const { settings, setSettings, themes } = useContext(AppContext);
  const navigate = useNavigate();

  const handleTheme = (key) => {
    localStorage.setItem("theme", key);
    const newSettings = { ...settings, theme: key };
    setSettings(newSettings);
  };

  const homeStyle = {
    width: "5%",
    height: "5%",
    margin: "3%",
    padding: "0",
    marginTop: "0",
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1>Settings</h1>
        <AiFillHome style={homeStyle} onClick={() => navigate("/")} />
      </div>

      <h2>Color</h2>
      <div
        className="colorWheelContainer"
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <ColorWheel />
        <div
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "20px",
            backgroundColor: settings.color,
          }}
        ></div>
      </div>
      <h2>Theme</h2>
      <>
        {Object.keys(themes).map((key) => {
          const IconComponent = themes[key];
          return (
            <IconComponent
              key={key}
              style={{
                color: key === settings.theme ? settings.color : "black",
                width: "50px",
                height: "50px",
                margin: "10px",
              }}
              onClick={() => {
                console.log(key);
                handleTheme(key);
              }}
            />
          );
        })}
      </>
    </div>
  );
};

export default SettingsPage;
